import _DropdownOptionsService from "../services/dropdown-options-service";
import { IDropdownOptionsService } from "../types/services/dropdown-options-service";

const DropdownOptionsService: IDropdownOptionsService = new _DropdownOptionsService();

export default DropdownOptionsService;
